// Chinese translations (中文 - Simplified)
import { TranslationKeys } from './en';

export const zh: TranslationKeys = {
  // Common
  common: {
    home: '主页',
    settings: '设置',
    language: '语言',
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    close: '关闭',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: '设置',
    home: '主页',
    howToPlay: '如何游戏',
    pieceRules: '棋子规则',
    language: '语言',
    manageSubscription: '管理订阅',
    gameHistory: '游戏历史',
    analytics: '分析',
    premiumAccount: '高级账户',
    chatEnabled: '聊天：开启',
    chatDisabled: '聊天：关闭',
  },

  // Piece Rules
  pieceRules: {
    title: '棋子规则',
    description: '学习棋子移动',
    selectPiece: '选择棋子',
    selectedLabel: '已选择：',
    statusLabel: '状态：',
    statusReady: '准备就绪',
    statusViewing: '查看中',
    movement: '移动',
    regularMovement: '常规移动',
    ability: '能力',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: '移动',
    savage: '野蛮',
    birdtype: '鸟类',
    birdType: '鸟类',
    wallBlock: '墙体阻挡',
    moveblocks: '移动阻挡',
    wallclimb: '墙壁攀爬',
    lilypad: '荷叶跳跃',
    poisonous: '有毒',
    meadow: '草地',
    parasiticfungi: '寄生真菌',
    zombification: '僵尸化',
    fungi: '真菌',
    traverse: '穿越',
    capture: '捕获',
    faint: '昏厥',
    leap: '跳跃',
    swing: '摇摆',
    consume: '吞食',
    gamble: '赌博',
    entangle: '缠绕',
    ink: '墨汁',
    rotate: '旋转',
    backstep: '后退',
    trample: '践踏',
    charge: '冲锋',
    lane: '换道',
    snakestrike: '蛇击',
    shedskin: '蜕皮',
    house: '庇护',
    plant: '植物类型',
    planttype: '植物类型',
    capturehost: '捕获宿主',
    contagion: '传染',
    lonewolf: '孤狼',
    hop: '跳跃',
    decay: '腐败',
    slide: '滑行',
    block: '阻挡',
    poison: '毒素',
    infection: '感染',
    howl: '嚎叫',
  },

  // Animation Scenario Descriptions
  scenarios: {
    bearMovement: '熊可以向任何方向移动一格，就像国际象棋中的王一样',
    bearMovementPost: '它只会被友方棋子阻挡（除了树，熊可以爬树！）',
    bearSavage: '熊可以克服犀牛阻挡等防御能力',
    bearSavagePost: '使用野蛮能力，熊可以从任何方向捕获任何棋子，增加杀伤力',
    craneMovement: '鹤可以在任何直线上移动1或2格',
    craneMovementPost: '鹤甚至可以飞越其他棋子！',
    craneBirdType: '鸟类棋子无法捕获大型或捕食者棋子',
    craneBirdTypePost: '包括树、犀牛、熊和狼',
    frogMovement: '青蛙对角跳跃2格',
    frogMovementPost: '它不能只跳1格',
    frogWallBlock: '如果青蛙常规的2格路径被墙壁或另一个它无法捕获的棋子阻挡',
    frogWallBlockPost: '它的常规移动会缩短为对角1格',
    frogWallClimb: '当青蛙在棋盘边缘（A列或E列）时，它可以上下移动一格',
    frogWallClimbPost: '除非被友方棋子或青蛙前方的犀牛阻挡',
    frogLilypad: '如果青蛙在游戏中还没有移动过，它可以移动到前3排的任何位置，作为强大的防御能力',
    frogLilypadPost: '它可以使用荷叶跳跃捕获任何常规棋子，除了比自己等级更高的犀牛',
    frogPoisonous: '当任何动物捕获青蛙棋子时，你会中毒！',
    frogPoisonousPost: '中毒的棋子在恢复前跳过下一个可用回合',
    fungiMovement: '真菌可以向任何方向移动一格',
    fungiMovementPost: '它只会被友方棋子阻挡',
    fungiMeadow: '真菌降低敌方树棋子的移动能力',
    fungiMeadowPost: '敌方树棋子无法在真菌棋子1格范围内移动',
    fungiParasitic: '真菌可以固定敌方树棋子',
    fungiParasiticPost: '如果真菌在敌方树1格范围内，树无法移动，直到真菌离开或被捕获',
    fungiZombification: '真菌可以将捕获它的任何敌方动物棋子僵尸化，允许控制敌方动物一回合',
    fungiZombificationPost: '僵尸化的棋子在该回合也被视为真菌棋子，即使真菌是你的国王，游戏也不会在该回合后结束',
    fungiFungi: '蘑菇',
    fungiFungiPost: '如中毒、缠绕和病毒感染，但不包括僵尸化，因为它可以僵尸化其他棋子！',
    goatMovement: '山羊可以向任何方向移动一格',
    goatMovementPost: '山羊移动缓慢，但拥有强大的能力',
    goatTraverse: '山羊可以穿越任何其他相连的棋子，创造巨大的移动潜力',
    goatTraversePost: '山羊无法穿越昏厥的山羊或病毒等微小棋子',
    goatCapture: '山羊无法捕获任何捕食者',
    goatCapturePost: '例如熊或狼',
    goatFaint: '山羊可以昏厥以避免被捕获，除非是树和犀牛等大型棋子',
    goatFaintPost: '昏厥时，对手可以"站"在昏厥的山羊上以阻止其移动',
    monkeyMovement: '猴子可以向任何方向移动一格',
    monkeyMovementPost: '没有其他棋子可利用时，猴子的移动能力有限',
    monkeyLeap: '猴子像跳棋游戏一样，可以在直线上跳过其他棋子，拥有巨大的移动潜力',
    monkeyLeapPost: '但如果跳过敌方棋子，猴子必须掷骰子才能幸存，每跳过一个敌人就有1/6的捕获几率！',
    monkeySwing: '如果猴子跳过树，猴子获得额外回合',
    monkeySwingPost: '使用树荡产生猴子和树棋子之间强大的协同组合',
    monkeyConsume: '猴子可以吞食真菌棋子以获得额外回合',
    monkeyConsumePost: '与其他额外回合结合时，会产生毁灭性的组合',
    monkeyGamble: '除了掷骰子跳过敌人外，猴子还必须赌博才能捕获熊',
    monkeyGamblePost: '猴子必须在6面骰子上掷出5或6才能捕获熊，否则自己会被捕获',
    octopusMovement: '章鱼可以向任何方向移动一格',
    octopusCapture: '章鱼只能正交方向捕获',
    octopusCapturePost: '章鱼可以以复杂的方式捕获或缠绕棋子，所以请始终检查红色捕获和紫色缠绕！',
    octopusEntangle: '章鱼可以缠绕相邻的敌方棋子，固定它们，它甚至可以移动一格并缠绕敌人！',
    octopusEntanglePost: '被缠绕的棋子无法移动，直到章鱼离开或被捕获',
    octopusInk: '章鱼可以使用墨汁逃离危险情况，最多创建3个影子',
    octopusInkPost: '迷惑敌人并允许有趣的诱饵和躲避玩法',
    penguinMovement: '企鹅沿其设定方向直线滑行，直到墙壁或棋子阻挡其移动',
    penguinMovementPost: '移动后，企鹅可以在同一回合内设定其最终方向',
    penguinRotate: '比赛开始时，企鹅面朝下，必须旋转才能滑行，也称为睡眠状态',
    penguinRotatePost: '企鹅在任何位置都可以选择旋转而不是移动',
    penguinBirdType: '企鹅的捕获能力有限，像鹤一样，它无法捕获树、犀牛、熊或狼等大型或捕食者棋子',
    penguinBirdTypePost: '捕获后，企鹅可以旋转面向任何方向以进行战略定位',
    rhinoMovement: '犀牛只能向前移动两格',
    rhinoMovementPost: '它不能只移动1格',
    rhinoBackStep: '犀牛可以向后左或后右移动',
    rhinoCharge: '犀牛每局游戏可以使用冲锋能力向前额外移动一格',
    rhinoChargePost: '导致毁灭性的移动和捕获潜力',
    rhinoTrample: '犀牛用践踏捕获其行进路径上的所有棋子',
    rhinoTramplePost: '包括昏厥的山羊棋子',
    rhinoLane: '犀牛可以与另一个友方棋子交换位置，允许战略性换道玩法',
    rhinoLanePost: '但仅限于犀牛和友方棋子都没有移动过的情况',
    snakeMovement: '蛇可以在任何直线上移动2格',
    snakeMovementPost: '蛇移动恰好2格，除非被墙壁或友方棋子阻挡',
    snakeMoveBlocks: '当被墙壁或无法捕获的棋子阻挡时，蛇的移动缩短为1格',
    snakeMoveBlocksPost: '即使有中间棋子，它仍然可以移动两格',
    snakeStrike: '如果有敌方动物，蛇可以向前攻击3格',
    snakeStrikePost: '只要没有中间棋子阻挡其路径',
    snakeShedskin: '每局游戏一次，如果该格为空，蛇可以蜕皮并返回第一排',
    snakeShedskinPost: '这种重生每局游戏为蛇提供额外的生命',
    treeMovement: '树可以向前移动一格或在其所在排横向移动到任何格',
    treeMovementPost: '只要其路径未被阻挡',
    treeHouse: '树可以容纳其他棋子，保护它们免受无法爬树的敌人攻击。许多棋子可以爬树，如熊、鹤、青蛙、真菌、山羊、猴子、章鱼和蛇',
    treeHousePost: '当可以爬树的棋子攻击时，它只捕获被容纳的棋子，保护树本身',
    treeTrample: '树像犀牛一样，移动时捕获格子中的所有棋子',
    treeTramplePost: '包括昏厥的山羊',
    treePlant: '树是植物，不是动物，因此对多种效果免疫',
    treePlantPost: '如中毒、僵尸化、缠绕和病毒感染！',
    virusMovement: '病毒只能移动到距离两格远的被动物占据的格子',
    virusMoveBlocks: '如果病毒靠近墙壁，它只能移动一格',
    virusCaptureHost: '当病毒降落到（进入）任何动物棋子时，它只感染它们，被感染时它们仍可以继续常规游戏',
    virusCaptureHostPost: '病毒只在离开被感染宿主时才捕获棋子',
    virusContagion: '病毒可以在一回合内感染多个宿主从而快速传播',
    virusContagionPost: '传染允许病毒每回合进行任意多次合法移动',
    wolfMovement: '狼可以以L形移动，像国际象棋中的马一样',
    wolfMovementPost: '它不会被任何其他棋子阻挡',
    wolfLoneWolf: '狼',
    wolfLoneWolfPost: '当狼还有昏厥的山羊或病毒友军时，它也认为自己是孤狼',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 拖动探索 • 捏合缩放',
    dragToExploreDesktop: '🖱️ 拖动探索 • 滚动缩放',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: '返回',
    next: '下一个',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: '沙盒',
    description: '实验与练习',
    mode: '模式：',
    modeValue: '沙盒',
    status: '状态：',
    statusReady: '准备就绪',
    clearBoard: '清空棋盘',
  },

  // Multiplayer
  multiplayer: {
    title: '多人游戏',
    description: '寻找对手并竞争！',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',
    placementMatches: '定级赛',
    matchProgress: '比赛进度',
    gamesCompleted: '{games} / 10 场已完成',
    estimatedFinalRating: '预计最终评分',
    startingRating: '起始评分',
    matchesRemaining: '还剩{matches}场比赛',
    findPlacementMatch: '寻找定级赛',
    findMatch: '寻找比赛',
    competitive: '竞技',
    competitiveDesc: '寻找接近你排名的对手',
    quick: '快速',
    quickDesc: '快速找到竞技比赛',
    casual: '休闲',
    casualDesc: '非排名 - 娱乐游戏！',
    placement: '定级赛',
    placementDesc: '完成10场比赛以获得排名',
    startSearch: '开始搜索',
    searching: '搜索中...',
    mode: '模式：',
    inQueue: '队列中：',
    players: '玩家',
    playersPlural: '玩家',
    cancelSearch: '取消搜索',
    status: '状态：',
    ready: '准备就绪',
    selectingKing: '选择国王',
    placingPieces: '放置棋子',
    playing: '游戏中',
    gameType: '游戏类型：',
    opponent: '对手：',
    opponentElo: '对手ELO：',
    unranked: '未排名',
    dragPieces: '将棋子拖到棋盘上',
    lightPieces: '浅色棋子（你）',
    darkPieces: '深色棋子（你）',
    waitingForOpponent: '等待对手...',
    waitingForKing: '等待对手选择国王...',
    invalidPlacement: '无效放置',
    lightTurn: '轮到浅色玩家！',
    darkTurn: '轮到深色玩家！',
    onlyLightPieces: '你只能放置浅色棋子！',
    onlyDarkPieces: '你只能放置深色棋子！',
    mustPlaceOnRow: '{color}棋子必须放在第{row}行！',
    chat: '聊天',
    typeMessage: '输入消息...',
    send: '发送',
  },

  // Main Page
  mainPage: {
    title: '动物棋',
    subtitle: '人类的游戏',
    playersOnline: '当前在线玩家',
    placement: '排名',
    placementProgress: '排名',
    challengeAI: '挑战AI',
    multiplayer: '多人游戏',
    sandbox: '沙盒模式',
    tutorials: '教程',
    shop: '商店',
    collection: '收藏',
    history: '历史记录',
    analytics: '分析',
    courses: '课程',
    upgradeAccount: '升级账户',
    signIn: '登录',
    playAsGuest: '游客游戏',
    welcomeBack: '欢迎回来！您通常使用',
    privacyPolicy: 'Privacy Policy',

    // Learn the Pieces section
    learnThePieces: '学习棋子',

    // Learn the Rules section
    learnTheRules: '学习规则',
    premiseTitle: '前提',
    premiseText: 'Zodiac是一款有着隐藏国王的棋类游戏，从13种棋子中选择独特的阵容，然后在5×8的棋盘上虚张声势击败对手',
    selectionTitle: '选择',
    selectionText: '开始游戏时，秘密选择你的国王，然后与对手交替放置5个棋子，创造超过5000亿种初始状态之一。',
    objectiveTitle: '目标',
    objectiveText: '要么识破对手并捕获他们的秘密国王，要么让你的国王穿越棋盘赢得胜利！',
    competeTitle: '竞技',
    competeText: '在天梯上测试你的技能，开发新的个人技巧和策略，提升排名挑战最强者！',
    fullRulesButton: '点击此处查看完整官方规则',

    // FAQ section
    faqTitle: '常见问题',
    faqQuestion1: 'Zodiac棋背后的想法是什么？',
    faqAnswer1: 'Zodiac棋最初受到Bobby Fischer关于Chess960灵感的启发，我们想要扩展这个想法，对抗死记硬背，在不可思议的深度中庆祝人类的直觉！',
    faqQuestion2: '为什么我们需要国际象棋的替代品',
    faqAnswer2: '我们不需要！Zodiac不想让人们不玩国际象棋！这是一个具有自己优势和劣势的不同选择，我们希望你能从中获得乐趣，并帮助我们调整这个游戏，以激活新颖的玩法',
    faqQuestion3: '如何在Zodiac棋中获胜？',
    faqAnswer3: '有三种获胜方式：捕获对手的隐藏国王棋子，让自己的国王跑到棋盘的另一端，或者在有时间控制的比赛中，让对手的时间耗尽',
    faqQuestion4: '这是常见问题吗？',
    faqAnswer4: '是的，你可以查看常见问题中列出的任何问题，如果你想了解更多详细信息，可以点击问题，然后阅读以下详细信息，就像你现在正在阅读的这些详细信息',
    faqQuestion5: '一场典型的游戏需要多长时间？',
    faqAnswer5: '每场游戏都大不相同！有些游戏在2步内结束，有些可能需要30分钟，我们通常发现它们在5-15分钟的范围内！',
    faqQuestion6: '如果没有人能走合法步怎么办？',
    faqAnswer6: '如果一方无法走出任何合法步（僵局），游戏以平局结束。游戏也可以通过重复（相同的棋盘状态3次）或双方同意而以平局结束！',

    // About section
    aboutButton: '关于',
    developerInterface: '开发者界面',
  },

  // About Modal
  about: {
    title: '关于Zodiac',
    paragraph1: 'Zodiac是一款类似国际象棋的棋盘游戏，结合了像英雄联盟和刀塔这样的游戏中的棋子选择元素，以及扑克或社交推理游戏中的虚张声势机制。',
    paragraph2: '游戏的早期版本创建于2014年，名称为Shadow Chess（暗影棋）。2018年，它被重新设计成你今天看到的样子，包含一系列有趣的棋子，具有平衡但独特的移动模式和能力。',
    paragraph3: '我们的愿景是记录所有用户的游戏数据，以继续发展游戏，努力保持游戏的新鲜感，鼓励新颖的玩法。',
    paragraph4: 'Zodiac拥有巨大的搜索空间、隐藏信息和开局位置，我们希望避免AI的主导地位，让zodiac成为人类的游戏！',
  },

  // Privacy Policy
  privacy: {
    title: '隐私政策',
    lastUpdated: '最后更新',
    introduction: { title: '简介', p1: '欢迎使用Zodiac Chess（"我们"）。我们致力于保护您的隐私，确保您拥有安全愉快的游戏体验。本隐私政策解释了当您使用我们的网站和游戏时，我们如何收集、使用、披露和保护您的信息。', p2: '使用Zodiac Chess即表示您同意按照本政策收集和使用信息。如果您不同意我们的政策和做法，请勿使用我们的服务。', contact: '联系我们：' },
    infoCollect: { title: '我们收集的信息', accountInfo: { title: '1. 账户信息', item1: '电子邮件地址：用于账户创建和通信', item2: '用户名：您选择的显示名称', item3: '密码：加密并安全存储' }, gameData: { title: '2. 游戏数据', item1: '游戏统计：胜负、ELO评分、定级赛进度', item2: '游戏数据：棋子选择、所走棋步、使用的策略', item3: '比赛历史：游戏记录、对手信息', item4: '游戏内购买：装饰物品和高级会员状态' }, technicalData: { title: '3. 技术数据', item1: '设备信息：浏览器类型、操作系统', item2: '使用数据：访问的页面、停留时间、使用的功能', item3: '本地存储：语言偏好、界面设置、临时游戏状态' } },
    children: { title: '儿童隐私（COPPA合规）', p1: 'Zodiac Chess旨在适合全年龄段玩家，包括儿童。我们特别注意遵守《儿童在线隐私保护法》（COPPA）。', p2: '对于13岁以下的用户：我们建议儿童使用访客游戏模式，该模式不需要创建账户或收集数据。访客账户无法使用文字聊天功能，确保儿童不会与更广泛的互联网进行通信。如果儿童创建账户，我们在收集任何个人信息之前需要获得家长同意。', p3: '我们不会在未经验证的家长同意的情况下故意收集、使用或分享13岁以下儿童的个人信息。', p4: '聊天安全：所有访客/临时账户自动禁用文字聊天。标准账户持有者可以随时在账户设置中禁用聊天功能。', parentalRights: '家长有权：', right1: '查看孩子的个人信息', right2: '请求删除孩子的数据', right3: '拒绝进一步收集或使用孩子的信息', contactUs: '如需行使这些权利或您认为您的孩子向我们提供了个人信息，请立即通过contact@zodiac-chess.com联系我们' },
    howWeUse: { title: '我们如何使用您的信息', item1: '提供和改进我们的游戏服务', item2: '根据技能水平为您匹配合适的对手', item3: '跟踪您的进度、统计数据和成就', item4: '处理高级会员和装饰物品的付款', item5: '发送重要的服务公告和更新', item6: '分析游戏数据以改进游戏平衡和功能' },
    thirdParty: { title: '第三方服务', firebase: { title: 'Firebase（Google）', description: '我们使用Firebase进行身份验证、数据库存储和多人游戏功能。Firebase可能会按照其隐私政策收集某些数据。' }, stripe: { title: 'Stripe', description: '我们使用Stripe处理高级会员和应用内购买的付款。Stripe处理所有支付卡信息——我们永远不会看到或存储您的完整支付详情。' }, netlify: { title: 'Netlify', description: '我们的网站托管在Netlify上，可能会收集标准的网络托管数据，如IP地址和访问日志。' }, adsense: { title: 'Google AdSense（未来）', description: '我们可能通过Google AdSense展示广告。这些广告可能使用cookie进行个性化。对于面向儿童的内容，我们将仅展示非个性化广告以符合COPPA规定。' }, viewPolicy: '查看其隐私政策' },
    cookies: { title: 'Cookie和本地存储', description: '我们使用浏览器本地存储（类似于cookie）来增强您的体验：', item1: '语言偏好：记住您选择的语言', item2: '账户会话：保持您的登录状态（与Firebase配合使用）', item3: '游戏设置：记住您的界面偏好和沙盒设置', item4: '广告Cookie：如果您同意，第三方广告服务可能使用cookie进行广告个性化' },
    security: { title: '数据安全', p1: '我们实施适当的安全措施来保护您的信息：', item1: '密码加密：所有密码使用行业标准方法加密', item2: '安全连接：所有数据传输使用HTTPS加密', item3: 'Firebase安全规则：严格的数据库访问控制', p2: '但是，互联网上的传输方法没有100%安全的。虽然我们努力保护您的数据，但我们无法保证绝对安全。' },
    retention: { title: '数据保留', p1: '我们按以下方式保留您的数据：', item1: '活跃账户：在您的账户活跃期间保留数据', item2: '非活跃账户：如果您的账户10年未活动，我们可能会删除您的数据' },
    rights: { title: '您的隐私权利', description: '根据您所在的位置，您可能拥有以下权利：', access: { title: '访问：', description: '请求获取您的个人数据副本' }, correction: { title: '更正：', description: '请求更正您的数据' }, deletion: { title: '删除：', description: '请求删除您的账户和数据' }, portability: { title: '数据可移植性：', description: '请求以可移植格式获取您的数据' }, optOut: { title: '退出：', description: '退出营销通信' }, contact: '如需行使任何这些权利，请通过contact@zodiac-chess.com联系我们' },
    international: { title: '国际用户', p1: 'Zodiac Chess在新西兰运营。如果您从新西兰以外访问我们的服务，请注意您的信息可能会被传输到、存储和处理在新西兰以及我们服务提供商运营的其他国家。', p2: '使用我们的服务即表示您同意将您的信息传输到您居住国以外的国家，这些国家可能有不同的数据保护法律。' },
    changes: { title: '本隐私政策的变更', description: '我们可能会不时更新本隐私政策。我们将通过在此页面发布新的隐私政策并更新"最后更新"日期来通知您任何更改。重大变更将通过电子邮件或网站上的显著通知进行沟通。' },
    contact: { title: '联系我们', description: '如果您对本隐私政策或我们的数据做法有任何问题、疑虑或请求，请联系我们：', email: '电子邮件：', company: '公司：' },
    cookieConsent: {
      title: 'Cookie同意与控制',
      p1: '我们相信透明度并让您控制自己的数据。当您首次访问Zodiac Chess时，将看到一个cookie同意横幅，允许您选择要接受哪些类型的cookie。',
      categories: {
        title: 'Cookie类别',
        necessary: {
          title: '必要Cookie',
          description: '这些cookie对于网站正常运行至关重要。它们启用身份验证、游戏状态管理和安全等核心功能。您无法选择退出这些cookie。',
        },
        analytics: {
          title: '分析Cookie',
          description: '这些cookie通过Firebase Analytics收集匿名使用数据，帮助我们了解访问者如何与我们的网站互动。这有助于我们改善游戏体验。',
        },
        advertising: {
          title: '广告Cookie',
          description: '这些cookie由Google AdSense用于展示个性化广告。无论同意设置如何，高级会员永远不会看到广告。',
        },
      },
      control: {
        title: '如何控制Cookie',
        p1: '您有多种选项来管理cookie偏好：',
        method1: 'Cookie横幅：在首次访问时，您可以接受所有cookie、拒绝可选cookie或自定义您的偏好。',
        method2: '浏览器设置：大多数浏览器允许您通过设置菜单拒绝或删除cookie。',
        method3: '退出链接：对于广告cookie，您可以使用以下链接退出个性化广告。',
      },
      optOut: {
        title: '退出个性化广告',
        p1: '如果您想退出Google和其他广告网络的个性化广告，可以使用以下资源：',
        googleAds: 'Google广告设置 - 管理Google个性化广告',
        daa: '数字广告联盟（DAA） - 退出基于兴趣的广告',
        eaa: '欧洲互动数字广告联盟（EDAA） - 欧盟用户退出',
      },
      moreInfo: '如需了解我们使用的cookie的更多详细信息，请访问我们的',
      cookiePolicyLink: 'Cookie政策',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: '我们重视您的隐私',
    description: '我们使用cookie来增强您的体验、分析网站使用情况并展示个性化广告（仅限免费用户）。您可以随时自定义您的偏好。',
    acceptAll: '全部接受',
    rejectAll: '拒绝可选',
    customize: '自定义',
    savePreferences: '保存偏好',
    back: '返回',
    necessary: '必要Cookie',
    necessaryDesc: '网站正常运行所必需。无法禁用。',
    analytics: '分析Cookie',
    analyticsDesc: '帮助我们了解您如何使用网站，以改善您的体验。',
    advertising: '广告Cookie',
    advertisingDesc: '用于展示个性化广告（仅限免费用户，高级会员永远不会看到广告）。',
    privacyPolicy: '隐私政策',
    cookiePolicy: 'Cookie政策',
  },

  // Terms of Service
  terms: {
    title: '服务条款',
    lastUpdated: '最后更新',
    back: '返回',
    viewPrivacyPolicy: '查看隐私政策',
    acknowledgment: '使用Zodiac Chess即表示您确认已阅读、理解并同意遵守这些服务条款。',
    acceptance: {
      title: '1. 条款接受',
      p1: '通过访问和使用Zodiac Chess（"服务"），您接受并同意遵守这些服务条款。如果您不同意这些条款，请勿使用本服务。',
      p2: '我们保留随时修改这些条款的权利。在更改后继续使用服务即表示接受修改后的条款。',
    },
    description: {
      title: '2. 服务描述',
      p1: 'Zodiac Chess是一款在线策略棋盘游戏，拥有具有特殊能力的独特动物棋子。服务包括：',
      feature1: '与AI对手的单人游戏',
      feature2: '多人匹配和竞技游戏',
      feature3: '互动教程和学习资源',
      feature4: '账户创建和进度追踪',
      feature5: '可选的高级订阅功能',
      feature6: '外观自定义选项',
    },
    accounts: {
      title: '3. 用户账户',
      eligibility: {
        title: '3.1 资格条件',
        p1: '您必须年满13岁才能创建账户。13岁以下的用户可以在家长监督下使用访客游戏模式，但不能创建账户。',
      },
      responsibilities: {
        title: '3.2 账户安全',
        p1: '您有责任：',
        item1: '保持密码的机密性',
        item2: '您账户下发生的所有活动',
        item3: '立即通知我们任何未经授权的使用',
        p2: '我们不对因未经授权访问账户而产生的任何损失或损害承担责任。',
      },
      prohibited: {
        title: '3.3 禁止行为',
        p1: '您不得：',
        item1: '与他人共享您的账户',
        item2: '使用多个账户操纵排名',
        item3: '使用机器人、脚本或自动化工具玩游戏',
        item4: '骚扰、辱骂或威胁其他玩家',
        item5: '利用漏洞或故障获取不公平优势',
        item6: '逆向工程或试图访问我们的源代码',
        p2: '违反这些规则可能导致账户暂停或永久封禁。',
      },
    },
    premium: {
      title: '4. 高级订阅',
      billing: {
        title: '4.1 计费',
        p1: '高级订阅通过Stripe处理。购买高级订阅即表示您授权我们定期向您的支付方式收费，直到您取消为止。',
        p2: '订阅费用：',
        item1: '月度计划：在您购买日期的每月周年日收费',
        item2: '年度计划：在您购买日期的每年周年日收费',
        p3: '价格可能会更改，届时将提前30天通知活跃订阅者。',
      },
      cancellation: {
        title: '4.2 取消',
        p1: '您可以随时通过账户设置或联系支持取消订阅。取消将在当前计费周期结束时生效。',
        p2: '即使取消后，您仍将保留高级功能直到付费期结束。',
      },
      refunds: {
        title: '4.3 退款',
        p1: '月度订阅：不退还部分月份的费用。随时取消以停止未来收费。',
        p2: '年度订阅：如果在购买后7天内申请，可全额退款。7天后，退款由我们酌情决定。',
        p3: '装饰性购买：通常不可退款。如有特殊情况请联系支持。',
      },
    },
    acceptable: {
      title: '5. 可接受使用政策',
      p1: '您同意以尊重和合法的方式使用Zodiac Chess。禁止的行为包括：',
      item1: '作弊、黑客攻击或利用游戏机制',
      item2: '骚扰、仇恨言论或歧视性语言',
      item3: '发送垃圾信息、广告或推销',
      item4: '分享不当内容（如果启用了聊天或用户生成内容）',
      item5: '冒充其他用户或工作人员',
      item6: '试图干扰或损害服务',
      p2: '我们保留调查违规行为并采取适当行动的权利，包括终止账户并在必要时向当局报告。',
    },
    intellectual: {
      title: '6. 知识产权',
      ownership: {
        title: '6.1 我们的内容',
        p1: '所有游戏内容，包括但不限于游戏机制、美术作品、动画、音效、代码和设计，均归Animal Chess Limited或我们的许可方所有。',
        p2: '您被授予有限的、非独占的、不可转让的许可，仅用于个人娱乐目的使用服务。',
      },
      userContent: {
        title: '6.2 用户内容',
        p1: '通过提交内容（如聊天消息、用户名或个人资料信息），您授予我们在全球范围内免版税使用、展示和分发该内容的许可，以与服务相关联。',
        p2: '您声明您拥有或拥有您提交的任何内容的必要权利。',
      },
    },
    disclaimers: {
      title: '7. 免责声明和责任限制',
      p1: '服务按"原样"提供，不提供任何明示或暗示的保证。',
      p2: '我们不保证：',
      item1: '服务将不间断或无错误',
      item2: '缺陷将被纠正',
      item3: '服务没有病毒或有害组件',
      item4: '使用服务的结果将符合您的期望',
      p3: '在法律允许的最大范围内，我们不对以下情况承担责任：',
      item5: '任何间接、附带或后果性损害',
      item6: '利润、数据或商誉损失',
      item7: '服务中断或数据丢失',
      item8: '超过您在过去12个月内支付给我们的金额的损害',
    },
    privacy: {
      title: '8. 隐私',
      p1: '您对服务的使用还受我们隐私政策的约束，该政策解释了我们如何收集、使用和保护您的个人信息。',
      p2: '使用服务即表示您同意我们在隐私政策中描述的数据做法。',
    },
    changes: {
      title: '9. 条款变更',
      p1: '我们保留随时修改这些服务条款的权利。我们将通过以下方式通知用户重大变更：',
      item1: '向注册用户发送电子邮件通知',
      item2: '在网站上发布显著通知',
      item3: '更新本页顶部的"最后更新"日期',
      p2: '在更改后继续使用服务即表示接受修改后的条款。',
    },
    governing: {
      title: '10. 管辖法律',
      p1: '这些服务条款受新西兰法律管辖，不考虑法律冲突原则。',
      p2: '因这些条款或您使用服务而产生的任何争议应在新西兰法院解决。',
    },
    contact: {
      title: '11. 联系信息',
      p1: '如有关于这些服务条款的问题、疑虑或需要支持：',
      email: '电子邮件：',
      company: '公司：',
      address: '地址：',
    },
    severability: {
      title: '12. 可分割性',
      p1: '如果这些条款的任何规定被认定为不可执行或无效，该规定将在必要的最小范围内被限制或删除，其余规定将继续完全有效。',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Cookie政策',
    lastUpdated: '最后更新',
    browserInstructions: {
      chrome: '设置 → 隐私和安全 → Cookie',
      firefox: '设置 → 隐私和安全 → Cookie和网站数据',
      safari: '偏好设置 → 隐私 → Cookie和网站数据',
      edge: '设置 → 隐私、搜索和服务 → Cookie',
    },
    cookieTable: {
      name: 'Cookie名称',
      purpose: '用途',
      duration: '持续时间',
      type: '类型',
    },
    relatedPolicies: {
      title: '相关政策',
      description: '有关我们如何处理您的数据的更多信息，请参阅：',
      privacy: '隐私政策',
      terms: '服务条款',
    },

    introduction: {
      title: '简介',
      p1: '本Cookie政策解释了Zodiac Chess（"我们"）在您访问我们的网站时如何使用Cookie和类似技术。',
      p2: '通过使用我们的网站，您同意我们根据本政策使用Cookie。如果您不同意，请在浏览器设置中禁用Cookie或不使用我们的网站。',
    },
    what: {
      title: '什么是Cookie？',
      p1: 'Cookie是当您访问网站时放置在您设备（电脑、智能手机、平板电脑）上的小型文本文件。它们被广泛用于使网站高效运行并向网站所有者提供信息。',
      p2: 'Cookie有多种用途，包括记住您的偏好、分析网站使用情况以及启用某些功能。',
    },
    types: {
      title: '我们使用的Cookie类型',
      necessary: {
        title: '1. 必要Cookie',
        description: '这些Cookie对于网站正常运行至关重要。没有这些Cookie，您请求的服务将无法提供。',
        examples: '示例：',
        item1: '身份验证Cookie - 保持您登录到您的账户',
        item2: '安全Cookie - 防止欺诈活动',
        item3: '会话Cookie - 在会话期间维护您的游戏状态',
        item4: 'Cookie同意偏好 - 记住您的Cookie选择',
      },
      analytics: {
        title: '2. 分析Cookie',
        description: '这些Cookie通过收集有关页面访问、花费时间和使用功能的匿名信息，帮助我们了解访问者如何与我们的网站互动。',
        provider: '提供商：Firebase Analytics（Google）',
        purpose: '用途：',
        item1: '测量网站流量和用户参与度',
        item2: '识别热门功能和页面',
        item3: '了解用户人口统计（年龄范围、大致位置）',
        item4: '改善网站性能和用户体验',
      },
      advertising: {
        title: '3. 广告Cookie',
        description: '这些Cookie用于向您显示相关广告。它们还限制您看到广告的次数，并帮助衡量广告活动的效果。',
        provider: '提供商：Google AdSense',
        purpose: '用途：',
        item1: '根据您的兴趣展示个性化广告',
        item2: '衡量广告效果和参与度',
        item3: '防止同一广告显示太多次',
        note: '注意：高级订阅用户永远不会看到广告，无论Cookie设置如何。',
      },
    },
    firstThird: {
      title: '第一方Cookie与第三方Cookie',
      firstParty: {
        title: '第一方Cookie',
        description: '这些是由Zodiac Chess直接设置的Cookie。我们使用它们来实现网站的基本功能、身份验证和记住您的偏好。',
      },
      thirdParty: {
        title: '第三方Cookie',
        description: '这些是由我们使用的外部服务设置的Cookie，例如Google Analytics和Google AdSense。第三方Cookie受这些提供商的隐私政策约束。',
      },
    },
    specific: {
      title: '我们使用的具体Cookie',
      tableHeader: '以下是我们网站上使用的Cookie的详细列表：',
    },
    control: {
      title: '如何控制Cookie',
      consent: {
        title: '1. Cookie同意横幅',
        description: '当您首次访问我们的网站时，您会看到一个Cookie同意横幅。您可以：',
        item1: '接受全部 - 允许所有Cookie（必要的、分析和广告）',
        item2: '拒绝可选 - 仅允许必要的Cookie（无分析或广告）',
        item3: '自定义 - 准确选择您想要允许的Cookie类型',
      },
      browser: {
        title: '2. 浏览器设置',
        description: '大多数网络浏览器允许您通过其设置控制Cookie。您可以：',
        item1: '阻止所有Cookie',
        item2: '仅接受第一方Cookie',
        item3: '在每次浏览会话后删除Cookie',
        item4: '查看和删除单个Cookie',
        links: '以下是常用浏览器的Cookie管理链接：',
      },
      optOut: {
        title: '3. 退出工具',
        description: '对于广告Cookie，您可以选择退出个性化广告：',
        googleLink: 'Google广告设置',
        googleDesc: ' - 管理Google个性化广告',
        daaLink: 'Digital Advertising Alliance（DAA）',
        daaDesc: ' - 退出基于兴趣的广告',
        edaaLink: 'European Interactive Digital Advertising Alliance（EDAA）',
        edaaDesc: ' - 欧盟特定的退出工具',
      },
    },
    impact: {
      title: '禁用Cookie的影响',
      p1: '如果您禁用或拒绝Cookie，请注意：',
      item1: '网站的某些部分可能无法正常运行',
      item2: '您可能需要在每次访问时重新输入您的偏好',
      item3: '您可能会被登出您的账户',
      item4: '网站运行需要必要的Cookie - 禁用它们将阻止您使用核心功能',
    },
    updates: {
      title: '本Cookie政策的更新',
      p1: '我们可能会不时更新本Cookie政策，以反映我们实践中的变化，或出于法律、监管或运营原因。',
      p2: '我们将通过更新本页顶部的"最后更新"日期来通知您重要变更。请定期查看本政策。',
    },
    contact: {
      title: '联系我们',
      p1: '如果您对我们使用Cookie或本Cookie政策有疑问，请联系我们：',
      email: '电子邮件：',
      company: '公司：',
    },
  },

  // Game
  game: {
    yourTurn: '你的回合',
    opponentTurn: '对手的回合',
    victory: '胜利！',
    defeat: '失败',
    draw: '平局',
    resign: '认输',
    offerDraw: '提议平局',
  },

  // Game Info
  gameInfo: {
    title: '游戏信息',
    sandboxMode: '沙盒模式',
    lightTurn: '浅色方回合',
    darkTurn: '深色方回合',
    yourTurn: '你的回合',
    opponentTurn: '对手回合',
    aiThinking: 'AI思考中...',

    // Selection states
    selecting: '选择 {piece}',
    observing: '观察 {piece}',
    selectingZombified: '选择僵尸化的敌方 {piece}',
    selectionLocked: '选择锁定在 {piece}',
    selectionLockedPenguin: '企鹅被选择锁定',

    // Hints
    clickToFaint: '点击 {piece} 使其昏厥',
    clickToRotate: '点击 {piece} 旋转',
    clickToInk: '点击 {piece} 喷墨',
    zombifiedWarning: '⚠️ 僵尸化时，{piece} 在移动前会旋转！',

    // Monkey bonus turn
    monkeySwing: '猴子完成摆荡，请移动猴子完成奖励回合',
    monkeyConsume: '猴子吃掉了蘑菇，请移动猴子完成奖励回合',

    // Virus bonus turn
    virusInfecting: '病毒正在感染，继续回合或点击病毒结束回合',

    // Penguin bonus turn
    penguinRotate: '企鹅完成滑行 - 请选择最终旋转方向',
    penguinCaptureRotate: '企鹅完成捕获 - 请选择最终旋转方向',
    penguinZombified: '僵尸化的企鹅已旋转 - 用滑行/捕获完成回合（僵尸化将结束）',

    // Capture restrictions
    cannotCapture: '{piece} 无法捕获：{targets}',
    cannotInfect: '{piece} 无法感染：{targets}',
    cannotEntangle: '{piece} 无法缠绕：{targets}',
    monkeyBearRoll: '{piece} 必须掷出5-6才能捕获敌方 {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: '熊',
    Crane: '鹤',
    Frog: '青蛙',
    Fungi: '蘑菇',
    Goat: '山羊',
    Monkey: '猴子',
    Octopus: '章鱼',
    Penguin: '企鹅',
    Rhino: '犀牛',
    Snake: '蛇',
    Tree: '树',
    Virus: '病毒',
    Wolf: '狼',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: '移动说明',
    emptyState: '从左侧面板选择一个能力查看详细信息。',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI竞技场',
    tagline: '选择一个AI对战或观看AI之间的对决！',

    // Player labels
    lightPlayer: '浅色玩家',
    darkPlayer: '深色玩家',
    humanPlayer: '人类玩家',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: '哨兵',
    aiAlchemist: '炼金术士',
    aiZenith: '巅峰',
    aiTrapper: '陷阱师',
    aiHunter: '猎人',
    aiWisp: '精灵',
    aiCreature: 'Creature',
    aiWeaver: '织者',

    // Time Frames
    timeFast: '快速',
    timeStandard: '标准',
    timeDeep: '深度',

    // Thinking time
    thinkingTime: '思考时间',

    // Info box
    matchupLabel: '对局：',
    statusLabel: '状态：',
    statusPaused: '已暂停',
    statusAIThinking: 'AI思考中...',
    statusInGame: '游戏中',
    statusReady: '准备就绪',
    matchupLocal2P: '本地双人',
    matchupPlayerVs: '玩家 vs',
    matchupVsPlayer: 'vs 玩家',

    // Buttons
    startButton: '开始',
    startRandomButton: '随机开始',
    newGameButton: '新游戏',
    resumeButton: '继续',
    pauseButton: '暂停',
    pauseQueuedButton: '暂停（排队中...）',
    viewKingsButton: '查看王',
    hideKingsButton: '隐藏王',
    viewKingsQueuedButton: '查看王（排队中...）',
    hideKingsQueuedButton: '隐藏王（排队中...）',
    homeButton: '主页',
    toggleKingVisibility: '切换王的可见性',

    // Warning modal
    invalidPlacement: '无效放置',
    okButton: '确定',
    warningLightTurn: '轮到浅色玩家放置棋子！',
    warningDarkTurn: '轮到深色玩家放置棋子！',
    warningLightRow: '浅色棋子必须放置在第0行（你的主场行）！',
    warningDarkRow: '深色棋子必须放置在第7行（你的主场行）！',
    warningOccupied: '这个格子已被占用！请选择一个空格。',
    warningKingRequired: '在放置第5个棋子之前必须先放置你的王（{kingType}）！',

    // Piece selection
    dragPieces: '拖动棋子到棋盘',
    lightPieces: '浅色棋子',
    darkPieces: '深色棋子',

    // Mobile
    selectYourKing: '选择你的王',
    selectPieceToPlace: '选择要放置的棋子',
    moveHistory: '移动历史',
    historyButton: '历史',
    backButton: '返回',
    lightTurn: '浅色方回合',
    darkTurn: '深色方回合',
  },

  // Donation
  donation: {
    title: '支持Zodiac Chess',
    supportDevelopment: '支持开发',
    story1: '你好！你的支持帮助我继续改进这款独特的游戏！添加新功能、维护服务器，并让Zodiac Chess对社区保持免费。',
    story2: '即使是小额捐款也会产生巨大的影响，让这个项目保持活力。感谢你成为Zodiac Chess旅程的一部分 :)',
    selectAmount: '选择金额',
    customAmount: '或输入自定义金额：',
    total: '总计：',
    donateButton: '立即捐款',
    processing: '处理中...',
    disclaimer: '捐款支持开发和服务器成本。感谢你的慷慨！',
    invalidAmount: '请输入大于0的有效金额',
    error: '处理捐款时出错。请重试。',
  },

  // Game End Popup
  gameEnd: {
    victory: '胜利！',
    defeat: '失败！',
    draw: '平局！',
    wonBy: '通过{condition}获胜',
    lostBy: '通过{condition}失败',
    drawBy: '通过{condition}平局',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: '弑王',
      race: '竞速胜利',
      timeout: '超时',
      threefold: '三次重复',
      noMoves: '无有效移动',
      draw: '平局',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: '升级到高级版',
    accountRequired: '升级到高级版之前需要创建一个永久账户。',
    createAccountPrompt: '创建账户以保存进度并解锁高级功能！',
    subtitle: '解锁强大功能以增强你的Zodiac Chess体验！',
    features: {
      history: '账户历史',
      historyItem1: '存储和调用所有以前的游戏',
      historyItem2: '从任意点重玩旧游戏以评估策略',
      historyItem3: '使用深度分析来分析棋盘位置和精彩走法机会',
      analytics: '分析',
      analyticsItem1: '访问游戏统计数据',
      analyticsItem2: '通过大量指标分析用户的棋子和王的选择',
      analyticsItem3: '了解哪些策略流行以及什么有效！',
      course: '课程',
      courseItem1: '获取最新课程以提高技能',
      courseItem2: '向专家学习策略和概念',
      courseItem3: '获取关于自己游戏的技巧以分析自己的弱点',
    },
    createAccount: '创建账户',
    upgradeNow: '立即升级',
    cancel: '取消',
  },

  // Premium Modal
  premium: {
    title: '高级功能',
    accessDenied: '抱歉，你没有高级账户，暂时无法访问这些功能！',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: '哎呀！出了点问题',
    errorMessage: '处理付款时遇到问题。别担心，你没有被收费。',
    whatHappened: '发生了什么？',
    notCompleted: '你的付款未完成。可能是由于：',
    reasons: {
      cancelled: '付款已取消',
      declined: '银行卡被拒绝',
      connection: '结账时连接问题',
      expired: '会话已过期',
    },
    whatToDo: '你可以怎么做？',
    actions: {
      tryDifferentCard: '用另一张卡重试',
      tryDifferentCardDesc: '使用另一种付款方式',
      retryPayment: '重试付款',
      retryPaymentDesc: '有时简单的重试就能成功',
      checkBank: '联系银行确认',
      checkBankDesc: '确保你的卡有足够的余额',
    },
    tryAgain: '再次尝试升级',
    returnHome: '返回主页',
    contactSupport: '需要帮助？请联系support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
